import { render, staticRenderFns } from "./SmallButton.vue?vue&type=template&id=14a169bc&scoped=true&"
import script from "./SmallButton.vue?vue&type=script&lang=js&"
export * from "./SmallButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallButton.vue?vue&type=style&index=0&id=14a169bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a169bc",
  null
  
)

export default component.exports